import BottomNavLayout from "../../components/BottomNavLayout";
import PubHeader from "../../components/PubHeader";
import CardList from "./CardList";

const IcCard = () => {
  return (
    <BottomNavLayout>
      <PubHeader title="IC卡列表" />
      <CardList />
    </BottomNavLayout>
  )
}

export default IcCard